$.fn.webhotelierForm = function(options) {

	var el = $(this);

	var settings = $.extend({
		// "split_dates": $(this).data("split_dates"),
		// "icon_dates": $(this).data("icon_date"),
	}, options);

	var checkinDateSplit = el.find("#checkin-date-split");

	function getField(id) {
		var el = $("#" + id + "-picker");
		return el.length ? el : null;
	}

	function fillSplitDates(id) {
		var el = getField(id);
		if (el !== null) {
			var date = el.datepicker("getDate");
			el.parent().find(".day").text(date.getDate());
			el.parent().find(".month").text(date.toLocaleString(document.documentElement.lang,{month: "short"}));
			el.parent().find(".year").text(date.getFullYear());
		}
	}

	function pickerSetup(id, date) {
		var el = getField(id);
		var minDate = new Date(2022, 4, 1) < new Date() ? '0' : new Date(2022, 4, 1);
		var maxDate = new Date(2022, 4, 2) < new Date() ? '1' : new Date(2022, 4, 2);

		if (el !== null) {
			var checkin = (id === "checkin");

			el.datepicker({
				altField: el.get(0).form[id],
				altFormat: "yy-mm-dd",
				dateFormat: "d M yy",
				onSelect: function () {
					if (checkin && getField("checkout") !== null) {
						var constraint = new Date(el.datepicker("getDate"));
						constraint.setDate(constraint.getDate() + 1);
						getField("checkout").datepicker("option", "minDate", constraint);
					}
					if ( settings.split_dates ) {
						fillSplitDates(id);
					}
				},
				numberOfMonths: 2,
				mandatory: true,
				firstDay: 1,
				minDate: checkin ? minDate : maxDate,
				maxDate: "+2y",
				showOn: settings.icon_date ? "button" : "focus",
				buttonImage: settings.icon_date ? settings.icon_date : "",
				buttonImageOnly: settings.icon_date ? "true" : "false",
				buttonText: "Select date"
			});
			el.datepicker("setDate", date);

			if ( checkinDateSplit.length > 0 ) {
				fillSplitDates(id);
			}
		}
	}

	pickerSetup("checkin", "+0");
	pickerSetup("checkout", "+1");

	$("#checkin-date-split, #checkout-date-split").on("click", function() {
		$( this ).parent().find("input").datepicker( "show" );
	});


};

$(document).ready( function() {
	let $firstSlideshow = $("*[data-first-slideshow]");
	if ($firstSlideshow.length > 0) {
		$firstSlideshow.flickity({
			contain: true,
			autoPlay: 4000,
			cellSelector: ".slideshow-cell",
			accessibility: true,
			prevNextButtons: false,
			pageDots: $firstSlideshow.find(".slideshow-cell").length > 1,
			setGallerySize: false,
			imagesLoaded: true,
			lazyLoad: true,
			draggable: ">1",
			wrapAround: true
		});
	}

	if ( $("body").hasClass('page-template-gallery') ) {
		var getUrlParameter = function getUrlParameter(sParam) {
			var sPageURL = window.location.search.substring(1),
				sURLVariables = sPageURL.split('&'),
				sParameterName,
				i;

			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');

				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
				}
			}
			return false;
		};

		if ( getUrlParameter('renovated-photos') ) {
			let tabs = document.querySelectorAll(".nav-pills .nav-item a");

			tabs.forEach(function(e) {
				if ( e.id.includes('renovated-photos') ) {
					e.click();

				}
			});

		}


	}
});


